import React from 'react'
import { LineupLoader } from 'loaders'
import PropTypes from 'prop-types'
import LineupEditContainer from './LineupEditContainer'

const LineupEdit = ({ history, match }) => (
  <LineupLoader lineupUuid={match.params.lineupUuid}>
    <LineupEditContainer history={history} match={match} />
  </LineupLoader>
)

LineupEdit.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      lineupUuid: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
}

export default LineupEdit
